import React, { useEffect } from "react";
import { Wrench } from "lucide-react";
import api from "../../api/api";
import { useMaintenance } from "../../context/MaintenanceContext";

const MaintenanceScreen: React.FC = () => {
  const { maintenanceData, setMaintenanceMode } = useMaintenance();



  useEffect(() => {
    const intervalId = setInterval(async () => {
      try {
        // Ping an endpoint to check if maintenance is over.
        // We will try fetching banners or simple endpoint if we don't know the health endpoint.
        // If it succeeds (returns 200), we can just reload the page to clear the state.
        const response = await api.get("/categories", {
          // Add a custom header or query param if needed, or just let interceptor handle
        });
        
        // If we get here, it means the API is working again
        // (interceptor didn't throw 503)
        // Check if it's still in maintenance mode via response body
        if (response.data?.is_maintenance || response.data?.maintenance?.is_enabled) {
          // Still in maintenance
        } else {
          // Maintenance is over! Reload to start fresh
          window.location.reload();
        }
      } catch (error) {
        // 503 will be caught here, we just ignore and wait for next interval
      }
    }, 30000); // 30 seconds

    return () => clearInterval(intervalId);
  }, []);

  const message =
    maintenanceData?.detail ||
    maintenanceData?.message ||
    "Sizga yanada qulay xizmat ko'rsatish uchun ilovamizda texnik ishlar olib borilmoqda. Tez orada yana xizmatingizda bo'lamiz!";

  const estimatedEndAt = maintenanceData?.estimated_end_at;

  return (
    <div className="fixed inset-0 z-[9999] bg-[#f5f6f8] flex flex-col justify-center items-center px-4 font-sans text-center">
      <div className="bg-[#e9ecf8] rounded-full p-8 mb-6">
        <Wrench size={48} className="text-[#003cff]" strokeWidth={2.5} />
      </div>

      <h1 className="text-2xl font-semibold text-gray-900 mb-3">
        Texnik ishlar olib borilmoqda
      </h1>

      <p className="text-gray-500 max-w-md mb-8 leading-relaxed">
        {message}
      </p>

      {estimatedEndAt && (
        <p className="text-gray-500 text-sm mb-6 bg-gray-200 px-4 py-2 rounded-md">
          Kutilayotgan yakunlanish vaqti: {new Date(estimatedEndAt).toLocaleString()}
        </p>
      )}


    </div>
  );
};

export default MaintenanceScreen;
